import React from 'react';
import { Box } from '@mui/material';
import type { ChangesAgencyFilterCatalog } from '../../types/changesAgencyFilter';
import { AgencyFilterCheckboxRow } from './AgencyFilterCheckboxRow';
import { AgencyFilterGroupHeading, AgencyFilterSubHeading } from './AgencyFilterSectionHeadings';

export type AgencyFilterTab = 'federacao' | 'estados' | 'municipios';

type Props = {
  tab: AgencyFilterTab;
  catalog: ChangesAgencyFilterCatalog;
  selected: string[];
  onToggle: (agencyName: string) => void;
};

export function AgencyFilterGroupedMenuList({ tab, catalog, selected, onToggle }: Props) {
  const fed = catalog.federacao ?? [];
  const est = catalog.estados ?? [];
  const mun = catalog.municipios ?? [];

  if (tab === 'federacao') {
    return (
      <Box>
        {fed.map((name) => (
          <AgencyFilterCheckboxRow
            key={name}
            label={name}
            checked={selected.includes(name)}
            onClick={() => onToggle(name)}
          />
        ))}
      </Box>
    );
  }

  if (tab === 'estados') {
    return (
      <Box>
        {est.map((g) => (
          <Box key={g.state}>
            <AgencyFilterGroupHeading>{g.state}</AgencyFilterGroupHeading>
            {(g.names ?? []).map((name) => (
              <AgencyFilterCheckboxRow
                key={`${g.state}-${name}`}
                label={name}
                checked={selected.includes(name)}
                onClick={() => onToggle(name)}
              />
            ))}
          </Box>
        ))}
      </Box>
    );
  }

  return (
    <Box>
      {mun.map((st) => (
        <Box key={st.state}>
          <AgencyFilterGroupHeading>{st.state}</AgencyFilterGroupHeading>
          {(st.cities ?? []).map((city) => (
            <Box key={`${st.state}-${city.city}`}>
              <AgencyFilterSubHeading>{city.city}</AgencyFilterSubHeading>
              {(city.names ?? []).map((name) => (
                <AgencyFilterCheckboxRow
                  key={`${st.state}-${city.city}-${name}`}
                  label={name}
                  checked={selected.includes(name)}
                  onClick={() => onToggle(name)}
                  dense
                />
              ))}
            </Box>
          ))}
        </Box>
      ))}
    </Box>
  );
}
